import { useEffect } from "react";

import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { KioskDashboardQueryKeys } from "modules/KioskDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useKiosksQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const query = useTypedQuery({
    queryKey: KioskDashboardQueryKeys.kiosks,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.kiosks,
    enabled: Boolean(selectedLocation?.id)
  });

  useEffect(() => {
    if (selectedLocation?.id) query.refetch();
  }, [selectedLocation?.id]);

  return query;
};
